var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSend = function SvgIconSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 20",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 0
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "m.438.54 5.954 7.993 13.711 1.543-13.71 1.346-5.955 8.19 29.018-9.536z"
  }))));
};
export { SvgIconSend as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzAgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBzdHJva2Utd2lkdGg9IjAiPgogICAgPGcgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEuMDAwMDAwLCAtNi4wMDAwMDApIj48L2c+CiAgICAgICAgPHBvbHlnb24gZmlsbD0iI0Q4RDhEOCIKICAgICAgICAgICAgICAgICBwb2ludHM9IjAuNDM4NDM2Mzk2IDAuNTQwMDIzNDYyIDYuMzkyMTEyODcgOC41MzI3NTI1IDIwLjEwMzQ1NzYgMTAuMDc1NTcxNiA2LjM5MjExMjg3IDExLjQyMjM0MzkgMC40Mzg0MzYzOTYgMTkuNjExMTE5OCAyOS40NTYwOTQ3IDEwLjA3NTU3MTYiPjwvcG9seWdvbj4KICAgIDwvZz4KPC9zdmc+";